/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from 'react';
import { Form, Row, Col, Tab, Tabs, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { loaderActions } from '../../../features/Loader/LoaderSlice';
import { AllCompanyIDs } from '../../../components/shared/Company';
import API from '../../../Services/API';
import VendorForm from './vendorForm';

function VendorsManagement() {
  const navigate = useNavigate();
  const { role } = useSelector((state) => state.auth);
  if (role !== 'admin') {
    navigate('/');
  }

  const isLoading = useSelector((state) => state.loader.open);

  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();

  const [vendors, setVendors] = useState([]);
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [currentVendor, setCurrentVendor] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [currentTab, setCurrentTab] = useState(() => {
    if (
      (searchParams.get('vendorPortalStatus') &&
        searchParams.get('vendorPortalStatus') === 'none') ||
      searchParams.get('vendorPortalStatus') === 'null' ||
      searchParams.get('vendorPortalStatus') === null
    ) {
      return 'enabled';
    }
    return searchParams.get('vendorPortalStatus');
  });
  const [search, setSearch] = useState('');

  const vendorStatusTabs = [
    {
      title: 'Enabled Vendors',
      status: 'enabled'
    },
    {
      title: 'All Vendors',
      status: 'all'
    }
  ];

  async function editVendor(vendor) {
    setCurrentVendor(vendor);
    setShowModal(true);
  }

  function hideModal(status = 'close') {
    setShowModal(false);
    if (status === 'reload') {
      fetchVendors();
    }
  }

  async function fetchVendors() {
    await dispatch(loaderActions.show());

    const companyIds = AllCompanyIDs;
    const vendors = [];
    for (let i = 0; i < companyIds.length; i++) {
      const params = {
        company_id: companyIds[i],
        $filter: ''
      };
      if (currentTab === 'enabled') {
        params.$filter = 'enableVendorPortal eq true';
      } else {
        delete params.$filter;
      }
      const resp = await API().get('/vendor_list', { params });
      if (resp && resp.data && resp.data.value) {
        vendors.push(...resp.data.value);
      }
    }
    setVendors(vendors);
    await dispatch(loaderActions.hide());
  }

  const VendorTabs = vendorStatusTabs.map((group, idx) => {
    return (
      <Tab eventKey={group.status} title={group.title} key={idx}>
        <div className="card user-profile-list shadow-none">
          <div className="card-body shadow-none">
            <div className="dt-responsive table-responsive shadow-none">
              <table id={`${group.role}-list-table`} className="table nowrap shadow-none">
                <thead>
                  <tr>
                    <th>Vendor #</th>
                    <th>Company</th>
                    <th>Name</th>
                    <th>Vendor Type</th>
                    <th>Shipping Method</th>
                    {currentTab === 'all' && <th>Status</th>}
                    <th>Assigned Emails</th>
                    <th>CC Emails</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {vendors.length > 0 ? (
                    filteredVendors.map((vendor, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{vendor.vendNo}</td>
                          <td>{vendor.companyBadgeText}</td>
                          <td>{vendor.vendName}</td>
                          <td>{vendor.VendorType}</td>
                          <td>{vendor.vpFreightType === 'SeaRailAir' ? 'SeaRailAir' : 'Truck'}</td>
                          {currentTab === 'all' && (
                            <td>
                              {vendor.enableVendorPortal ? (
                                <i className="feather icon-check-circle text-c-green"></i>
                              ) : (
                                <i className="feather icon-slash text-c-red"></i>
                              )}
                            </td>
                          )}
                          <td>{vendor.emailAddress.split(',').filter(Boolean).length}</td>
                          <td>
                            {(vendor.emailAddressCC &&
                              vendor.emailAddressCC.split(',').filter(Boolean).length) ||
                              0}
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-info"
                              onClick={() => editVendor(vendor)}
                            >
                              <i className="feather icon-edit"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : !isLoading ? (
                    <tr>
                      <td colSpan={7}>
                        <Alert variant={'danger'}>No Vendors found!</Alert>
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            </div>
            {search.length > 0 && filteredVendors.length === 0 && (
              <Alert variant={'danger'}>No Vendors found!</Alert>
            )}
          </div>
        </div>
      </Tab>
    );
  });

  useEffect(() => {
    const filtered = vendors.filter((vendor) => {
      return (
        vendor.vendNo.toLowerCase().includes(search.toLowerCase()) ||
        vendor.vendName.toLowerCase().includes(search.toLowerCase()) ||
        (vendor.emailAddress && vendor.emailAddress.toLowerCase().includes(search.toLowerCase())) ||
        (vendor.emailAddressCC &&
          vendor.emailAddressCC.toLowerCase().includes(search.toLowerCase()))
      );
    });
    setFilteredVendors(filtered);
  }, [vendors, search]);

  useEffect(() => {
    fetchVendors();
    setSearchParams(`?${new URLSearchParams({ vendorPortalStatus: currentTab })}`);
  }, [currentTab]);

  return (
    <div className="page-header">
      <Row className="px-4 text-right">
        <Col></Col>
        <Col md="auto">
          <Form.Control
            size="sm"
            type="text"
            className="mr-2"
            placeholder="Search Vendors"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
      </Row>
      <Tabs
        defaultActiveKey={currentTab}
        transition={false}
        id="vendor-tab"
        onSelect={(tab) => setCurrentTab(tab)}
      >
        {VendorTabs}
      </Tabs>
      <VendorForm show={showModal} onHide={hideModal} vendor={currentVendor} />
    </div>
  );
}

export default VendorsManagement;
